import PanelBox from '../../components/PanelBox';
import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { Card, Table, Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, Upload, message } from 'antd';
import { updateUser, updateProfile } from '../../actions/auth';

const FormItem = Form.Item;

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUser:    (data) => dispatch(updateUser(data)),
    updateProfile: (data) => dispatch(updateProfile(data)),
  }
}


class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: null,
      last_name: null,
      notification_to_email: null,
      notification_to_telegram: null,
      loading: false
    };
    this.setData = this.setData.bind(this)
    this.toggleEmailNotify = this.toggleEmailNotify.bind(this)
    this.disableTelegramNotify = this.disableTelegramNotify.bind(this)
  }

  setData(fieldName, value) {
    let stateObject = {}
    stateObject[fieldName] = value
    this.setState(stateObject)
  }

  updateUserData() {
    let updateUserData = {}
    let updateProfileData = {}
    const updatingValue = ['first_name','last_name']
    const updatingProfileValue = ['notification_to_email','notification_to_telegram']

    updatingValue.map((value)=> 
      {
        let updateItem = {}
        updateItem[value] = this.state[value]
        this.state[value] && Object.assign(updateUserData,updateItem)
      }
    )
    
    updatingProfileValue.map((value)=> 
      {
        let updateItem = {}
        updateItem[value] = this.state[value]
        this.state[value] != null && Object.assign(updateProfileData,updateItem)
      }
    )
    // console.warn(updateUserData)
    // console.warn(updateProfileData)

    Object.keys(updateUserData).length || Object.keys(updateProfileData).length ? (this.setState({loading: true}), this.props.updateProfile(updateProfileData), this.props.updateUser(updateUserData)) : null
  }

  componentWillReceiveProps(nextProps) {
    this.state.loading == true && nextProps.user ? (
        this.setState({loading: false}),
        message.success('Profile has been updated!')
      ) : null   
  }

  toggleEmailNotify(data) {
    this.setState({notification_to_email:data})
  }

  disableTelegramNotify(data) {
    this.setState({notification_to_telegram:false})
  }


  render() {
    const formProfileField = {
      labelCol: { span: 14 },
      wrapperCol: { span: 10 },
      colon: false
    };
    return (
      <PanelBox title={"User Profile"}>
        <Row type="flex" justify="center">
          <Form>
            <FormItem
              {...formProfileField}
              label="First name"
              hasFeedback
            >
              <Input
                prefix={<Icon type="user" style={{ fontSize: 13 }} />}
                style={{ width: 150 }}
                defaultValue={this.props.user.first_name}
                onChange={(e) => this.setData('first_name',e.target.value)}/>
            </FormItem>
            <FormItem
              {...formProfileField}
              label="Last name"
              hasFeedback
            >
              <Input
                prefix={<Icon type="contacts" style={{ fontSize: 13 }} />}
                style={{ width: 150 }}
                defaultValue={this.props.user.last_name}
                onChange={(e) => this.setData('last_name',e.target.value)}/>
            </FormItem>
            <FormItem
              {...formProfileField}
              label="Telegram secret key"
              hasFeedback
            >
              <Input
                prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                style={{ width: 150 }}
                value={this.props.user.profile.telegram_secret_key}/>
            </FormItem>
             <FormItem
              {...formProfileField}
              label="Telegram notification"
              hasFeedback
            >
              {this.props.user.profile.notification_to_telegram ? ( 
                <div style={{'display':'flex', 'justifyContent':'center'}}>
                  <span style={{marginLeft:10}}> Enabled </span>  
                  <Button 
                    onClick={(e)=>this.disableTelegramNotify(e.target.checked)}
                    style={{marginLeft:10}}>Disable</Button>
                </div>) : (
                    <a href="http://telegram.me/dddct_bot">http://telegram.me/dddct_bot</a>
                  )} 
            </FormItem>
           <FormItem
              {...formProfileField}
              label="E-mail notification"
              hasFeedback
            >
              <Checkbox 
                onClick={(e)=>this.toggleEmailNotify(e.target.checked)}
                defaultChecked={this.props.user.profile.notification_to_email ? true : false}/>
            </FormItem>

          </Form>
        </Row>
        <Row type="flex" justify="center">
          <Button
            type="primary"
            htmlType="submit"
            onClick={(e) => this.updateUserData()}
            loading={this.state.loading}
          >
           Update
          </Button>
        </Row>
      </PanelBox>
    )
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(UserProfile)


// WEBPACK FOOTER //
// ./src/views/User/index.jsx